import { ICellRendererParams } from 'ag-grid-community';
import type { ComponentProps } from 'react';
import { AdPreview } from '@aleph/shared-components';
import { capitalize } from 'lodash';

type AdPreviewFormat = 'AUDIO' | 'VIDEO' | 'DISPLAY';

export function getAdPreviewPropsFromRowData(data: ICellRendererParams['data']): ComponentProps<typeof AdPreview> {
	const groupFormat = data?.parent?.groupAssetFormat as string | undefined;
	const format: AdPreviewFormat = groupFormat === 'VIDEO' ? 'VIDEO' : groupFormat === 'IMAGE' ? 'DISPLAY' : 'AUDIO';
	const primaryAssetUrl = data?.adAsset?.mediaUrl ?? '';

	return {
		advertiserName: data?.adAdvertiserName ?? '',
		headline:       data?.adTagline ?? '',
		callToAction:
		// eslint-disable-next-line no-unsafe-optional-chaining
      capitalize((data?.adCallToActionText || data?.adCallToActionKey).toLowerCase().replace(/_/g, ' '))
      ?? 'Learn more',
		destinationUrl: data?.adCallToActionClickthroughUrl ?? '',
		logo:           data?.adLogoAsset?.mediaUrl ?? '',
		companion:      data?.adCompanionAsset?.mediaUrl ?? '',
		audio:          format === 'AUDIO' ? primaryAssetUrl : '',
		video:          format === 'VIDEO' ? primaryAssetUrl : '',
		canvas:         data?.adCanvasAsset?.mediaUrl ?? undefined,
		// @ts-ignore
		format,
	};
}
